import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import ContactSubmissionsAdmin from 'pages/Landing/admin/ContactSubmissionsAdmin'

export const Route = createFileRoute('/_auth/_global/contact-submissions')({
  beforeLoad: requireGlobalRole(GlobalRoleType.GLOBAL_ADMIN),
  component: ContactSubmissionsAdmin,
})
